(() => {
    // State management
    const state = {
      selectedFilters: {
        category: "all",
        color: "all",
        zodiac: "all",
        ailment: "all",
      },
      colors: ["space-gray", "silver", "gold"],
  
      // Update a specific filter
      updateFilter(type, value) {
        this.selectedFilters[type] = value;
        renderUI();
      },
  
      // Clear all filters
      clearFilters() {
        this.selectedFilters = {
          category: "all",
          color: "all",
          zodiac: "all",
          ailment: "all",
        };
        renderUI();
      },
    };
  
    // DOM Elements
    const elements = {
      categorySelect: document.querySelector(".category-select"),
      clearFiltersBtn: document.querySelector(".clear-filters-btn"),
      colorOptions: document.querySelector(".color-options"),
      productGrid: document.querySelector(".product-grid"),
      zodiacSelect: document.querySelector(".zodiac-select"),
      ailmentSelect: document.querySelector(".ailment-select"),
    };
  
    // Event Handlers
    function setupEventListeners() {
      // Category filter change
      elements.categorySelect.addEventListener("change", (e) => {
        state.updateFilter("category", e.target.value);
      });

      // Zodiac filter change
      elements.zodiacSelect.addEventListener("change", (e) => {
        state.updateFilter("zodiac", e.target.value);
      });

      // Ailment filter change
      elements.ailmentSelect.addEventListener("change", (e) => {
        state.updateFilter("ailment", e.target.value);
      });
  
      // Clear filters button
      elements.clearFiltersBtn.addEventListener("click", () => {
        state.clearFilters();
  
        // Reset select elements
        elements.categorySelect.value = "all";
        elements.zodiacSelect.value = "all";
        elements.ailmentSelect.value = "all";
  
        // Update UI
        renderUI();
      });
    }

  


// function renderColorOptions() {
//   const uniqueColors = new Set();

//   // Step 1: Remember current selection
//   const select = document.querySelector(".color-select");
//   const currentValue = select.value;

//   // Step 2: Collect unique color values
//   document.querySelectorAll(".product-card").forEach((card) => {
//     const colorAttr = card.getAttribute("data-color");
//     if (colorAttr) {
//       try {
//         const colors = JSON.parse(colorAttr);
//         colors.forEach((c) => uniqueColors.add(c.trim().toLowerCase()));
//       } catch (e) {
//         colorAttr.split(",").forEach((c) => uniqueColors.add(c.trim().toLowerCase()));
//       }
//     }
//   });

//   // Step 3: Clear and rebuild the dropdown
//   select.innerHTML = `<option value="all">All Colors</option>`;

//   uniqueColors.forEach((hex) => {
//     const option = document.createElement("option");
//     option.value = hex;
//     option.textContent = hex;
//     select.appendChild(option);
//   });

//   // Step 4: Restore previous selection if still available
//   if ([...uniqueColors, "all"].includes(currentValue)) {
//     select.value = currentValue;
//   }

//   // Step 5: Attach event listener once
//   if (!select.dataset.listenerAttached) {
//     select.addEventListener("change", (e) => {
//       state.updateFilter("color", e.target.value);
//     });
//     select.dataset.listenerAttached = "true"; // Prevent attaching multiple times
//   }
// }

  // function renderColorOptions() {
  //       const uniqueColors = new Set();
  //       document.querySelectorAll(".product-card").forEach((card) => {
  //         const colorAttr = card.getAttribute("data-color");
  //         if (colorAttr) {
  //           colorAttr.split(",").forEach((c) => {
  //             uniqueColors.add(c.trim().toLowerCase());
  //           });
  //         }
  //       });
  //     console.log(uniqueColors)
  //       const colorOptionsContainer = document.querySelector(".color-options");
  //       colorOptionsContainer.innerHTML = "";


  //   const select = document.createElement("select");
  // select.className = "filter-select color-select";
  // select.setAttribute("aria-label", "Filter by Color");
    
  //       // Add default "All Colors" option
  //     const allOption = document.createElement("option");
  //     allOption.value = "all";
  //     allOption.textContent = "All Colors";
  //     select.appendChild(allOption);
    
  //     // Add color options
  //     uniqueColors.forEach((hex) => {
  //       const option = document.createElement("option");
  //       option.value = hex;
  //       option.textContent = hex;
  //       option.style.backgroundColor = hex;
  //       select.appendChild(option);
  //     });
    
  //     // Handle dropdown change
  //     select.addEventListener("change", (event) => {
  //       state.updateFilter("color", event.target.value);
  //     });
    
  //     colorOptionsContainer.appendChild(select);
      
  //       // const allButton = document.createElement("button");
  //       // allButton.textContent = "All Colors";
  //       // allButton.addEventListener("click", () => {
  //       //   state.updateFilter("color", "all");
  //       // });
  //       // colorOptionsContainer.appendChild(allButton);
      
  //       // uniqueColors.forEach((hex) => {
  //       //   const colorButton = document.createElement("button");
  //       //   colorButton.className = "color-circle";
  //       //   colorButton.style.backgroundColor = hex;
  //       //   colorButton.title = hex;
  //       //   colorButton.addEventListener("click", () => {
  //       //     state.updateFilter("color", hex);
  //       //   });
  //       //   colorOptionsContainer.appendChild(colorButton);
  //       // });
  //     }

function renderColorOptions() {
  const uniqueColors = new Set();

  document.querySelectorAll(".product-card").forEach((card) => {
    const colorAttr = card.getAttribute("data-color");
    if (colorAttr) {
      colorAttr.replace(/[\[\]"]+/g, "")
        .split(",")
        .forEach((color) => {
          const cleaned = color.trim().toLowerCase();
          if (cleaned) uniqueColors.add(cleaned);
        });
    }
  });

  const container = document.querySelector(".color-options");
  container.innerHTML = "";

  // All Colors Button
  const allButton = document.createElement("button");
  allButton.textContent = "All Colors";
  allButton.className = "color-swatch all-colors";
  if (state.selectedFilters.color === "all") {
    allButton.classList.add("selected");
  }
  allButton.addEventListener("click", () => {
    state.updateFilter("color", "all");
    renderColorOptions();
    document.querySelector("#color-toggle").textContent = "All Colors";
    closeDropdown();
  });
  container.appendChild(allButton);

  // Color swatches
  uniqueColors.forEach((hex) => {
    const btn = document.createElement("button");
    btn.className = "color-swatch";
    btn.style.backgroundColor = hex;
    btn.title = hex;

    if (state.selectedFilters.color === hex) {
      btn.classList.add("selected");
      document.querySelector("#color-toggle").textContent = hex;
    }

    btn.addEventListener("click", () => {
      state.updateFilter("color", hex);
      renderColorOptions();
      document.querySelector("#color-toggle").textContent = hex;
      closeDropdown();
    });

    container.appendChild(btn);
  });
}

// Dropdown toggle
document.querySelector("#color-toggle").addEventListener("click", () => {
  document.querySelector(".color-dropdown").classList.toggle("open");
});

// Close dropdown on outside click
document.addEventListener("click", (e) => {
  const dropdown = document.querySelector(".color-dropdown");
  if (!dropdown.contains(e.target)) {
    dropdown.classList.remove("open");
  }
});

function closeDropdown() {
  document.querySelector(".color-dropdown").classList.remove("open");
}

  
    // Filter product cards based on current filters
    function filterProducts() {
      const productCards = document.querySelectorAll(".product-card");
  
      productCards.forEach((card) => {
        const category = card.getAttribute("data-category");
        const color = (card.getAttribute("data-color")|| "").split(",").map(z => z.trim().toLowerCase());
        const zodiacAttr = card.getAttribute("data-zodiac") || "";
        const zodiacList = zodiacAttr.split(",").map(z => z.trim().toLowerCase());

        // const ailmentAttr = ;
        const ailmentList = (card.getAttribute("data-ailment") || "").split(",").map(z => z.trim().toLowerCase());
  
        const categoryMatch =
          state.selectedFilters.category === "all" ||
          category === state.selectedFilters.category;
  
        const colorMatch =
          state.selectedFilters.color === "all" ||
          color.includes(state.selectedFilters.color.toLowerCase());

        const zodiacMatch =
          state.selectedFilters.zodiac === "all" ||
          zodiacList.includes(state.selectedFilters.zodiac.toLowerCase());

        const ailmentMatch =
          state.selectedFilters.ailment === "all" ||
          ailmentList.includes(state.selectedFilters.ailment.toLowerCase());
  
        if (categoryMatch  && colorMatch && zodiacMatch && ailmentMatch) {
          card.style.display = "block";
        } else {
          card.style.display = "none";
        }
      });
    }
  
    // Update UI based on current state
    function renderUI(showSpinner = true) {
      
        const spinnerOverlay = document.getElementById("loading-spinner");
        const productGrid = document.querySelector(".product-grid");
      
        // Show spinner and blur
            if(showSpinner){
              spinnerOverlay.classList.remove("hidden");
              productGrid.style.filter = "blur(2px)";
            }
      
      
              setTimeout(() => {
          // Update filter UI
          elements.categorySelect.value = state.selectedFilters.category;
          // elements.priceSelect.value = state.selectedFilters.price;
      
          // Render color options
          renderColorOptions();
      
          // Apply filtering
          filterProducts();
      
          // Hide spinner after rendering
          if (showSpinner) {
            spinnerOverlay.classList.add("hidden");
            productGrid.style.filter = "none";
          }
        }, 300);

    }
  
    // Initialize the application
    function init() {
      setupEventListeners();
      renderUI(false);
    }
  
    // Start the application when DOM is loaded
    document.addEventListener("DOMContentLoaded", init);
  })();